import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useContext } from 'react';
import { color } from '../../../styles/styles.js';
import { FCTheme } from '../../../theming/FCTheme.js';
import { StyledTable } from './style.js';
import { TableContextProvider } from './TableContext.js';
import TableHeader from './TableHeader.js';
import TableRow from './TableRow.js';
import TableBody from './TableBody.js';
import TableCell from './TableCell.js';

var Table = function Table(_a) {
  var _b = _a.padding,
      padding = _b === void 0 ? '5px' : _b,
      _c = _a.zebraStriping,
      zebraStriping = _c === void 0 ? false : _c,
      zebraStripeColor = _a.zebraStripeColor,
      _d = _a.freezeFirstColumn,
      freezeFirstColumn = _d === void 0 ? false : _d,
      children = _a.children,
      frozenColumnWidth = _a.frozenColumnWidth,
      _e = _a.highlightOnHover,
      highlightOnHover = _e === void 0 ? false : _e,
      rest = __rest(_a, ["padding", "zebraStriping", "zebraStripeColor", "freezeFirstColumn", "children", "frozenColumnWidth", "highlightOnHover"]);

  var themeContext = useContext(FCTheme);
  var zebraStripeColorValue = themeContext.theme === 'dark' ? color.darkModeDark : zebraStripeColor ? zebraStripeColor : '#ebebeb';
  var state = {
    padding: padding,
    freezeFirstColumn: freezeFirstColumn,
    zebraStriping: zebraStriping,
    zebraStripeColor: zebraStripeColorValue,
    frozenColumnWidth: frozenColumnWidth,
    theme: themeContext.theme,
    highlightOnHover: highlightOnHover
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTable, __assign({
    theme: themeContext.theme
  }, rest), /*#__PURE__*/React.createElement(TableContextProvider, {
    value: state
  }, children)));
};

Table.Header = TableHeader;
Table.Row = TableRow;
Table.Cell = TableCell;
Table.Body = TableBody;
export default Table;
export { Table };